import React, { useState } from "react"
import styles from "../components/AuthPageContainer.module.css"

export const SignUpLink = () => {
  // clerk-js buildSignInUrl() appends its redirect params AFTER the hash
  // (`/signin#/?redirect_url=...`) because our <SignIn> is hash-routed, so
  // a plain "/signup" href would drop them for a brand-new user clicking
  // this link. Forward the current hash — capture it once on mount so
  // Clerk's hash-router rewrites don't lose it later.
  const [signupHref] = useState<string>(() =>
    typeof window === "undefined" ? "/signup" : `/signup${window.location.hash}`
  )

  return (
    <p className={styles.accountLink}>
      Don&apos;t have an account?{" "}
      <a className="signin-footer-link" href={signupHref}>
        Sign up
      </a>
    </p>
  )
}
